import React from "react";
import clsx from "clsx";
import { RegistrationLayoutRoot } from "./RegistrationLayout.style";
import {
  REGISTRATION_KEYBOARD_SCOPE_ATTR,
  RegistrationKeyboardFocusStyles,
} from "./registrationFocusStyles";
import { RegistrationMotionStyles } from "./registrationMotionStyles";
import { RegistrationA11yAnnouncer } from "./RegistrationA11yAnnouncer";

export const RegistrationLayout = ({
  children,
  header,
  containScroll,
}) => (
  <RegistrationLayoutRoot
    {...REGISTRATION_KEYBOARD_SCOPE_ATTR}
    className={clsx(
      "fill-width max-full-width flex-y pos-relative",
      containScroll ? "overflow-hide full-height" : "overflow-auto"
    )}
  >
    <RegistrationKeyboardFocusStyles />
    <RegistrationMotionStyles />
    <RegistrationA11yAnnouncer />
    {header}
    <div
      className={clsx(
        "registration-layout__main flex flex-y flex-1 fill-width pos-relative overflow-hide",
        containScroll && "full-height"
      )}
    >
      {children}
    </div>
  </RegistrationLayoutRoot>
);
